import apisComponent from './apis/apis.component';
import profileComponent from './profile/profile.component';
import documentationComponent from './documentation/documentation.component';
import applicationsComponent from './apps/apps.component';
import applicationComponent from './application/application.component';
import createappComponent from './createapp/createapp.component';
import oauthDone from './oauthDone/oauthDone.component';
import swagger from './swagger/swagger.component';
import main from './main/main.component';
import loginComponent from './login/login.component';
import logoutComponent from './logout/logout.component';
import supportComponent from './support/support.component';
import monitoringComponent from './monitoring/monitoring.component';

export const PAGES = [    
    oauthDone,    
    swagger,
    apisComponent,
    profileComponent,    
    applicationsComponent,
    documentationComponent,
    applicationComponent,
    createappComponent,
    loginComponent,
    logoutComponent,
    supportComponent,
    monitoringComponent,
    main //should be the very last page
];


// WEBPACK FOOTER //
// ./client/app/pages.js